import { i18n } from '@/i18n/i18n'
import { mapGetters } from 'vuex'
import Configuration from '@/agilis/util/Configuration'
import ProfileMenu from '@/agilis/components/ProfileMenu/ProfileMenu.vue'
import PushNotificationButton from '@/agilis/components/PushNotificationButton/PushNotificationButton.vue'

export default {
  name: 'AppBar',

  components: {
    ProfileMenu,
    PushNotificationButton
  },

  computed: {
    ...mapGetters({
      'configLoaded': 'configurationStore/configurationLoadingCompleted',
      'applicationId': 'contextStore/applicationId',
      'applicationName': 'contextStore/applicationName',
      'workspaceName': 'contextStore/workspaceName',
      'workspaceId': 'contextStore/workspaceId'
    }),

    appBarTitle () {
      let title = i18n.t('label.appBarTitle')
      if (this.configLoaded) {
        if (this.applicationName) {
          title = title +
            ' >> ' + i18n.t(this.applicationName) +
            (this.workspaceName ? ' >> ' + i18n.t(this.workspaceName) : ' >> Settings')
        }
      }
      return title
    },

    workspaceDescription () {
      return this.applicationId && this.workspaceId &&
        this.$t(Configuration.auth.findWorkspace(this.applicationId, this.workspaceId)?.description)
    },

    username () {
      return this.$store.state.userDataStore.userId
    }
  },

  methods: {
    onClickHome: function (lang) {
      this.$store.commit('contextStore/setSelectedContextDefault')
      this.$router.agilis.home()
    }
  }
}
